import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Globe2, FileCheck, Users, Plane, Scale } from "lucide-react";

const STEPS = [
  ["Eligibility pre-assessment", "Candidate and host-company eligibility review."],
  ["Program planning", "Program design, documentation preparation and sponsor coordination."],
  ["Counsel & sponsor", "Coordination with qualified immigration counsel and authorized program sponsors."],
  ["Consular & arrival", "Embassy-interview preparation, relocation coordination and arrival support."],
];

export default function Mobility() {
  return (
    <div className="relative">
      <Navbar />
      <section className="pt-32 pb-16 relative">
        <div className="absolute -top-20 right-0 h-96 w-96 rounded-full bg-azure/10 blur-[120px]" aria-hidden />
        <div className="mx-auto max-w-6xl px-5 lg:px-8 relative">
          <div className="flex items-center gap-2 mb-4">
            <Globe2 className="text-azure" size={20} />
            <span className="label-mono text-azure">Global Talent Mobility Program</span>
          </div>
          <h1 className="font-display font-bold tracking-tighter text-4xl sm:text-5xl max-w-3xl">
            Bring exceptional international talent to the United States.
          </h1>
          <p className="mt-5 text-muted max-w-2xl leading-relaxed">
            A premium, separately-priced service starting from <span className="text-ink font-medium">$25,000</span>.
            Team Assembly coordinates international-mobility cases with qualified immigration professionals and,
            where applicable, authorized program sponsors.
          </p>
        </div>
      </section>

      <section className="relative z-10 pb-16">
        <div className="mx-auto max-w-6xl px-5 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {STEPS.map(([t, b], i) => (
            <div key={t} className="bg-surface p-7">
              <div className="flex items-center gap-3 mb-3">
                <span className="font-mono text-xs text-faint">0{i + 1}</span>
                {[FileCheck, Users, Scale, Plane][i] && (() => { const Icon = [FileCheck, Users, Scale, Plane][i]; return <Icon size={18} className="text-azure" />; })()}
              </div>
              <h3 className="font-display font-bold text-lg text-ink">{t}</h3>
              <p className="mt-2 text-sm text-muted leading-relaxed">{b}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="relative z-10 pb-24">
        <div className="mx-auto max-w-6xl px-5 lg:px-8">
          <div className="rounded-xl border border-amber/20 bg-amber/5 p-6">
            <p className="text-sm text-amber font-medium mb-2">Important disclaimer</p>
            <p className="text-sm text-muted leading-relaxed">
              Team Assembly is not a law firm and does not provide legal advice. Immigration-related services
              may be coordinated with qualified immigration counsel and authorized program sponsors. No
              immigration or visa outcome can be guaranteed. Team Assembly does not directly issue, approve or
              guarantee any visa. Eligibility and approval remain subject to sponsor, consular and government review.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
